import { useSearchParams } from "react-router";

export function NoRowsOverlay() {
  const [searchParams] = useSearchParams({});

  const search = searchParams.get("search");
  const filters = searchParams.get("filters");

  return (
    <div className="flex h-full w-full items-center justify-center">
      {search || filters ? (
        <div>No rows matched search or filters</div>
      ) : (
        <div>No Rows</div>
      )}
    </div>
  );
}
